// extracted by mini-css-extract-plugin
module.exports = {"iframe":"Peak_iframe__NQVtv","preloader":"Peak_preloader__uNJ7g"};